import React from 'react';
import MonthSelectBox from '../../../common/MonthSelectBox';
import YearSelectBox from '../../../common/YearSelectBox';

function LearnerInfoForm({ handleFormData }) {
  return (
    <section>
      <h2>학습자 정보 입력</h2>
      <div className="item">
        <div className="input_title">이름</div>
        <div className="input_cont">
          <div className="input_box white_box">
            <input
              type="text"
              name="learnerName"
              onChange={handleFormData}
              placeholder="이름 입력"
            />
          </div>
          <div className="select_area cls">
            <div className="area1 cls">
              <YearSelectBox />
              <MonthSelectBox />
            </div>
            <div className="area2 cls">
              <div className="box_radio">
                <input
                  type="radio"
                  name="learnerGender"
                  id="male"
                  value="M"
                  onChange={handleFormData}
                />
                <label htmlFor="male">남</label>
              </div>
              <div className="box_radio">
                <input
                  type="radio"
                  name="learnerGender"
                  id="female"
                  value="F"
                  onChange={handleFormData}
                />
                <label htmlFor="female">여</label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="notice">※ 회원가입 후 학습자를 추가할 수 있습니다.</div>
    </section>
  );
}

export default LearnerInfoForm;